import React from "react";
import SubscribeForm from "../SubscribeForm";

/**
 * Recap CTA. Dark navy editorial band. No "subscription card". The form
 * is presented as a continuation of the page, not a sales artifact.
 */
export default function SecondCta() {
    return (
        <section
            id="recap"
            className="bt-section"
            data-testid="section-second-cta"
            style={{
                backgroundColor: "var(--bt-navy)",
                color: "var(--bt-paper)",
                borderTop: "1px solid var(--bt-ink)",
            }}
        >
            <div className="bt-shell">
                <div
                    className="bt-recap-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 56,
                    }}
                >
                    {/* Editorial column */}
                    <div>
                        <p
                            className="signal"
                            style={{
                                marginBottom: 24,
                                color: "var(--bt-brass-soft)",
                            }}
                        >
                            № 06 &nbsp;·&nbsp; The recap
                        </p>
                        <h2
                            className="t-display"
                            style={{
                                margin: 0,
                                marginBottom: 20,
                                color: "var(--bt-paper)",
                                maxWidth: 540,
                            }}
                        >
                            One brief. Once a month. Free.
                        </h2>
                        <p
                            className="t-lede"
                            style={{
                                margin: 0,
                                marginBottom: 32,
                                color: "rgba(244, 239, 229, 0.82)",
                                maxWidth: 540,
                            }}
                        >
                            If you read this far, you&rsquo;re the kind of person we
                            wrote it for.
                        </p>
                        <hr
                            style={{
                                border: 0,
                                height: 1,
                                background: "rgba(244,239,229,0.25)",
                                margin: "32px 0",
                                maxWidth: 540,
                            }}
                        />
                        <dl
                            style={{
                                margin: 0,
                                display: "grid",
                                gridTemplateColumns: "auto 1fr",
                                rowGap: 14,
                                columnGap: 24,
                                maxWidth: 540,
                                color: "rgba(244,239,229,0.82)",
                            }}
                        >
                            <Row label="Cadence" value="First Tuesday, every month" />
                            <Row label="Length" value="Under 1,500 words per issue" />
                            <Row label="Cost" value="Nothing, ever" />
                            <Row
                                label="Editorial"
                                value="Independent. No Wall Street money."
                            />
                        </dl>
                    </div>

                    {/* Form column — no card, no border. Just labels and lines. */}
                    <div data-testid="recap-form-wrap">
                        <SubscribeForm instance="recap" tone="dark" />
                    </div>
                </div>
            </div>
        </section>
    );
}

function Row({ label, value }) {
    return (
        <>
            <dt
                className="signal"
                style={{
                    color: "rgba(244,239,229,0.55)",
                    paddingTop: 4,
                }}
            >
                {label}
            </dt>
            <dd
                className="t-body"
                style={{
                    margin: 0,
                    color: "var(--bt-paper)",
                    fontSize: 16,
                }}
            >
                {value}
            </dd>
        </>
    );
}
